import React from 'react'
import { Card, Typography, Box, useTheme, CardActionArea } from '@mui/material'
import useCustomStyles from '../hooks/CustomStylesHook'
import Colors from '../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: 2,
    backgroundColor: theme.palette.primary.light,
    borderRadius: '8px',
    padding: '5px 10px',
    minWidth: '200px',
    // height: '120px',
  },
  cardSelected: {
    backgroundColor: theme.palette.primary.main,
  },
  iconBox: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  contentBox: {
    padding: '5px',
    marginLeft: '16px',
  },
  title: {
    fontSize: '14px',
    color: '#6b6b6b',
    marginBottom: '4px',
  },
  count: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '4px',
  },
  percentageBox: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
  },
  positive: {
    color: '#28a745',
    display: 'flex',
    alignItems: 'center',
  },
  negative: {
    color: '#dc3545',
    display: 'flex',
    alignItems: 'center',
  },
  textSelected: {
    color: `${Colors.WHITE_BACKGROUND} !important`,
  },
  iconSelected: {
    color: theme.palette.primary.main,
  },
})

export interface CardProps {
  icon: React.ReactNode
  title: string
  count: number
  percentage: number
  selected: boolean
  onClick: () => void
}

const StatusCard: React.FC<CardProps> = ({
  icon,
  title,
  count,
  percentage,
  selected,
  onClick,
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const isPositive = percentage >= 0

  return (
    <Card elevation={0}>
      <CardActionArea
        className={`${classes?.card} ${selected ? classes?.cardSelected : ''}`}
        onClick={onClick}
      >
        <Box
          className={`${classes?.iconBox} ${
            selected ? classes?.iconSelected : ''
          }`}
        >
          {icon}
        </Box>
        <Box className={classes?.contentBox}>
          <Typography
            className={`${classes?.title} ${
              selected ? classes?.textSelected : ''
            }`}
          >
            {title}
          </Typography>
          <Box display={'flex'} flexDirection={'row'} gap={2}>
            <Typography
              className={`${classes?.count} ${
                selected ? classes?.textSelected : ''
              }`}
            >
              {count}
            </Typography>
            <Box
              className={`${classes?.percentageBox} ${
                isPositive ? classes?.positive : classes?.negative
              }`}
            >
              <span>{isPositive ? '▲' : '▼'}</span>
              <span className={`${selected ? classes?.textSelected : ''}`}>
                {Math.abs(percentage)}%
              </span>
            </Box>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  )
}

export default StatusCard
